import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const DialogConfirmation = (props: any) => {
  const onClickCloseDialog = () => props.setOpen(false);
  const { t } = useTranslation(["operation"]);
  return (
    <>
      <Dialog
        open={props.open}
        PaperProps={{
          sx: {
            minWidth: "600px !important",
            height: "194px",
            borderRadius: "4px",
          },
        }}
      >
        <DialogTitle>
          <Grid
            container
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid xs item>
              {props.title}
            </Grid>
            <Grid
              xs
              item
              sx={{
                justifyContent: "flex-end",
                display: "flex",
              }}
            >
              <CloseIcon
                color="disabled"
                fontSize="small"
                onClick={onClickCloseDialog}
              />
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>{props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={2} p={1} mr={1}>
            <Button
              sx={{
                maxWidth: "111px",
                maxHeight: "48px",
                minWidth: "111px",
                minHeight: "48px",
              }}
              variant="outlined"
              onClick={onClickCloseDialog}
            >
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  lineHeight: 2.25,
                  color: "#C8017D",
                }}
                variant="subtitle1"
              >
                {t("actionButtons.cancel")}
              </Typography>
            </Button>

            <Button
              sx={{
                maxWidth: "111px",
                maxHeight: "48px",
                minWidth: "111px",
                minHeight: "48px",
              }}
              variant="contained"
              color="accent"
              onClick={props.onClickConfirmAction}
            >
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  lineHeight: 2.25,
                  color:'white'
                }}
                variant="subtitle1"
              >
                {t("actionButtons.confirm")}
              </Typography>
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};
